import {gql} from '@apollo/client/core';

export const ListPageFragment = gql`
  fragment listPage on ListPage {
    storyblok
    title
    types {
      name
      attribute
    }
    objectIds {
      objectId
      weight
    }
  }
`;
